import React, { useCallback, useEffect, useState } from 'react';

import { ValueBox, ValueGroup, ValueStepper } from '@candu-ai/craft/ui';

interface Props {
  cards: number;
  onAddCard: () => void;
  onRemoveCard: () => void;
  inputNamePrefix?: string;
  maxValue?: number;
}

export const SelectCardStepper = ({
  cards,
  onAddCard,
  onRemoveCard,
  inputNamePrefix = 'form-input',
  maxValue,
}: Props) => {
  const [inputProps, setInputProps] = useState<{ cards: number }>({ cards });

  useEffect(() => {
    setInputProps({ cards });
  }, [cards]);

  const onChange = useCallback(
    (value: number) => {
      const difference = value - cards;
      if (difference === 0) {
        return;
      }
      [...new Array(Math.abs(difference))].forEach(() => {
        if (difference > 0) {
          onAddCard();
        } else {
          onRemoveCard();
        }
      });

      setInputProps({ cards: value });
    },
    [onAddCard, onRemoveCard, setInputProps, cards],
  );

  return (
    <ValueGroup>
      <ValueBox label="Number of cards">
        <ValueStepper
          value={inputProps.cards}
          name={`${inputNamePrefix}-cards`}
          scale="small"
          editable
          minValue={1}
          maxValue={maxValue}
          step={1}
          onChange={onChange}
          valueSuffix={maxValue ? `/${maxValue} max` : undefined}
        />
      </ValueBox>
    </ValueGroup>
  );
};
